module.exports = __webpack_public_path__ + "static/media/Master.3b168ec9.svg";